<template>
  <div class="banner wow fadeInUp mb-0"
  >
    <div class="banner__item" v-for="(item, id)  in items" :key="id">
      <img class="banner__img" :src="item.src" :alt="item.alt">
      <div class="banner__content">
        <h1 class="banner__title">{{ item.title }}</h1>
<!--        <a class="banner__btn btn-red" href="javascript:void(0)" onclick="scrollOnBlock(formNew)">Оставить
          заявку</a>-->
        <a class="banner__btn btn-red" href="/catalog/">Перейти в каталог</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
    elements: Array | Object | String,
  },
  data() {
    return {
      /*items: [
          {
              title: 'Комплексные упаковочные и химические решения',
              src: '/upload/banner.jpg',
              alt: 'banner'
          },
          {
              title: 'Комплексные упаковочные и химические решения 2',
              src: '/upload/banner.jpg',
              alt: 'banner'
          },
      ]*/
      items: this.elements,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (typeof $ !== 'undefined' && $.fn.slick) {
        $('.banner').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: this.elements.length > 1 ? true : false,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 5000,
          fade: true,
          speed: 1000,
          cssEase: 'ease-in-out'
        });
      }
    });
  }
}
</script>

<style scoped lang="scss">

.banner {
  max-width: 1840px;
  border-radius: 40px;
  overflow: hidden;

  &__item {
    position: relative;
    padding: 40px 40px 88px 40px;
    height: 100%;
    max-height: 760px;
    min-height: 760px !important;



    @media (max-width: 1024px) {
      max-height: 500px;
      min-height: 500px !important;
    }

    @media (max-width: 680px) {
      padding: 20px 20px 68px 20px;
    }

    &::before {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #0000004D;

    }
  }

  &__content {
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: start;
    margin-top: auto;
    width: 100%;
  }

  &__title {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 600;
    font-size: 88px;
    line-height: 94px;
    letter-spacing: 0px;
    color: #FFFFFF;
    margin: 0 0 40px 0 !important;
    z-index: 1;
    text-transform: none;

    @media (min-width: 1200px) {
      max-width: 68%;
    }

    @media (max-width: 1100px) {
      font-size: 66px;
      line-height: 110%;
    }

    @media (max-width: 850px) {
      font-size: 52px;
    }

    @media (max-width: 768px) {
      font-size: 48px;
    }

    @media (max-width: 630px) {
      font-size: 40px;
    }

    @media (max-width: 500px) {
      font-size: 36px;
    }

    @media (max-width: 425px) {
      font-size: 26px;
    }
  }

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -1;
    border-radius: 40px;
    animation: float 20s ease-in-out infinite;
    transform-origin: center center;
  }

  @keyframes float {
    0%, 100% {
      transform: translate(0, 0) scale(1);
    }
    25% {
      transform: translate(10px, -10px) scale(1.02);
    }
    50% {
      transform: translate(-5px, 5px) scale(1.01);
    }
    75% {
      transform: translate(-10px, -5px) scale(1.02);
    }
  }

  &__btn {
    font-size: 20px;
    line-height: 20px;
    letter-spacing: -0.05px;
    color: #ffffff !important;
    padding: 22px;
    border-radius: 32px;
    background: #FA4237;
    z-index: 1;

    @media (max-width: 500px) {
      font-size: 16px !important;
      padding: 16px !important;
    }
  }
}
</style>

<style lang="scss">

.banner {


  .slick-dots {
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    background: #FFFFFF66;
    padding: 16px 14px;
    border-radius: 56px;
    width: max-content;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slick-dots li {
    width: 43px;
    height: 8px;

    @media (max-width: 500px) {
      width: 20px;
      height: 4px;
    }
  }

  .slick-dots li button {
    width: 43px;
    height: 8px;
    @media (max-width: 500px) {
      width: 20px;
      height: 4px;
    }
  }

  .slick-dots li button:before {
    content: '';
    width: 43px;
    height: 8px;
    background: #EFEFEF;
    border-radius: 10px;
    opacity: 1;

    @media (max-width: 500px) {
      width: 20px;
      height: 4px;
    }
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
    background: #FA4237;
  }

  .slick-dotted.slick-slider {
    margin-bottom: 0 !important;
  }

  .slick-list {
    position: relative;
  }

  .slick-slide {
    display: flex !important;
  }
}
</style>